// Inventory Vouchers Management Permissions

// Withdraw Vouchers
export const VOUCHERS_WITHDRAW_CREATE = 230;
export const VOUCHERS_WITHDRAW_INDEX = 231;
export const VOUCHERS_WITHDRAW_VIEW = VOUCHERS_WITHDRAW_INDEX;
// Producing the document is one capability: download is gated by the print permission.
export const VOUCHERS_WITHDRAW_PRINT = 306;
export const VOUCHERS_WITHDRAW_DOWNLOAD = VOUCHERS_WITHDRAW_PRINT;

// Return Vouchers
export const VOUCHERS_RETURN_CREATE = 233;
export const VOUCHERS_RETURN_INDEX = 234;
export const VOUCHERS_RETURN_VIEW = VOUCHERS_RETURN_INDEX;
export const VOUCHERS_RETURN_PRINT = 308;
export const VOUCHERS_RETURN_DOWNLOAD = VOUCHERS_RETURN_PRINT;

// Transfer Vouchers
export const VOUCHERS_TRANSFER_CREATE = 236;
export const VOUCHERS_TRANSFER_INDEX = 237;
export const VOUCHERS_TRANSFER_VIEW = VOUCHERS_TRANSFER_INDEX;
export const VOUCHERS_TRANSFER_PRINT = 310;
export const VOUCHERS_TRANSFER_DOWNLOAD = VOUCHERS_TRANSFER_PRINT;

// Supply Vouchers
export const VOUCHERS_SUPPLY_CREATE = 239;
export const VOUCHERS_SUPPLY_INDEX = 240;
export const VOUCHERS_SUPPLY_VIEW = VOUCHERS_SUPPLY_INDEX;
export const VOUCHERS_SUPPLY_PRINT = 312;
export const VOUCHERS_SUPPLY_DOWNLOAD = VOUCHERS_SUPPLY_PRINT;

// Destruction Vouchers
export const VOUCHERS_DESTRUCTION_CREATE = 242;
export const VOUCHERS_DESTRUCTION_INDEX = 243;
export const VOUCHERS_DESTRUCTION_VIEW = VOUCHERS_DESTRUCTION_INDEX;
export const VOUCHERS_DESTRUCTION_PRINT = 314;
export const VOUCHERS_DESTRUCTION_DOWNLOAD = VOUCHERS_DESTRUCTION_PRINT;
